import { render } from "./LegalSection.vue?vue&type=template&id=44f07168&scoped=true"
import script from "./LegalSection.vue?vue&type=script&lang=js"
export * from "./LegalSection.vue?vue&type=script&lang=js"

import "./LegalSection.vue?vue&type=style&index=0&id=44f07168&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f07168"]])

export default __exports__